module.exports = __webpack_public_path__ + "static/76217e8c-9cfc-4ecd-8db0-ee46c49845ff-ee1019678e99b9d0f3f810a1bf46177f.webp";